<template>
  <router-link v-if="uid && path"
               class="ti-eye p-link pointer view-button-input__action"
               :to="{ path: `/${path}/${uid}` }"
               :target="settings.openAllLinksInSameTab ? '_self' : '_blank'"
               rel="noopener"
               :aria-label="$t('View')"
               @click.stop/>
</template>

<script>
import settings from "@/settings";
export default {
  name: 'InputViewLink',
  props: {
    path: {
      type: String,
      default: null,
    },
    uid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      settings
    }
  }
}
</script>

<style scoped>
.view-button-input__label {
  pointer-events: auto !important;
}

.view-button-input__text {
  display: inline-block;
  padding-right: 20px;
}

.view-button-input__action {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 2px;
  opacity: .7;
  padding: 2px;
  pointer-events: auto;
}

.view-button-input__action:hover {
  opacity: 0.7;
}

</style>